import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/views/auth/login'
import RegisterPage from '@/views/auth/register'
// import VerifyPhonePage from '@/views/auth/verify-phone'
import VerifyEmailPage from '@/views/auth/verify-email'
import ConfirmEmailPage from '@/views/auth/confirm-email'
import ForgotPasswordlPage from '@/views/auth/forgot-password'
import NewPasswordlPage from '@/views/auth/reset-password'
import IdcLayoutPage from '@/views/idc/index'
import IdcLayout2Page from '@/views/idc/index2'
import BillingPayment from '@/views/idc/billing/payment'
// import CreateOrder from '@/views/idc/order/create'
import PageNotFound from '@/views/idc/error-page/404'
import InternalServerError from '@/views/idc/error-page/500'

Vue.use(Router)

export default new Router({
  base: '/idc',
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: {
        auth: false,
        title: 'Đăng nhập'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: RegisterPage,
      meta: {
        auth: false,
        title: 'Đăng ký'
      }
    },
    {
      path: '/verify',
      name: 'verify',
      component: VerifyEmailPage,
      meta: {
        auth: true,
        title: 'Xác thực email'
      }
    },
    {
      path: '/confirm',
      name: 'confirm-email',
      component: ConfirmEmailPage,
      meta: {
        auth: false,
        title: 'Xác thực email'
      }
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: ForgotPasswordlPage,
      meta: {
        auth: false,
        title: 'Quên mật khẩu'
      }
    },
    {
      path: '/password_resets',
      name: 'password_resets',
      component: NewPasswordlPage,
      meta: {
        auth: false,
        title: 'Đặt mật khẩu mới'
      }
    },
    {
      path: '/',
      component: IdcLayoutPage,
      redirect: '/dashboard',
      children: [
        {
          path: '/dashboard',
          component: () => import('@/views/idc/dashboard/index'),
          name: 'dashboard.index',
          meta: { auth: true, title: 'Dashboard', icon: 'dashboard', layout: 'dashboard' }
        }
      ]
    },
    {
      path: '/cloud-server',
      component: IdcLayoutPage,
      redirect: '/cloud-server',
      children: [
        {
          path: '/cloud-server',
          component: () => import('@/views/idc/cloud-server/index'),
          name: 'cloud-server.index',
          meta: { auth: true, title: 'Cloud Server', icon: 'cloud-server', layout: 'cloud-server' }
        }
      ]
    },
    {
      path: '/cloud-server/create',
      component: IdcLayoutPage,
      redirect: '/cloud-server/create',
      children: [
        {
          path: '/cloud-server/create',
          component: () => import('@/views/idc/cloud-server/create'),
          name: 'cloud-server.create',
          meta: { auth: true, title: 'Tạo Server', icon: 'cloud-server', layout: 'cloud-server' }
        }
      ]
    },
    {
      path: '/cloud-server/plans',
      component: IdcLayoutPage,
      redirect: '/cloud-server/plans',
      children: [
        {
          path: '/cloud-server/plans',
          component: () => import('@/views/idc/cloud-server/plans'),
          name: 'cloud-server.plans',
          meta: { auth: true, title: 'Gói cước', icon: 'cloud-server', layout: 'plan' }
        }
      ]
    },
    {
      path: '/plans',
      component: IdcLayout2Page,
      redirect: '/plans',
      children: [
        {
          path: '/plans',
          component: () => import('@/views/idc/cloud-server/plans'),
          name: 'plans',
          meta: { auth: false, title: 'Gói cước', icon: 'cloud-server', layout: 'plan' }
        }
      ]
    },
    {
      path: '/plan/:id',
      component: IdcLayout2Page,
      redirect: '/plan/:id',
      children: [
        {
          path: '/plan/:id',
          component: () => import('@/views/idc/cloud-server/plan'),
          name: 'plan',
          meta: { auth: false, title: 'Tạo Server', icon: 'cloud-server', layout: 'cloud-server' }
        }
      ]
    },
    {
      path: '/cloud-server/plan/:id',
      component: IdcLayoutPage,
      redirect: '/cloud-server/plan/:id',
      children: [
        {
          path: '/cloud-server/plan/:id',
          component: () => import('@/views/idc/cloud-server/plan'),
          name: 'cloud-server.plan',
          meta: { auth: true, title: 'Tạo Server', icon: 'cloud-server', layout: 'cloud-server' }
        }
      ]
    },
    {
      path: '/cloud-server/:id/detail',
      component: IdcLayoutPage,
      redirect: '/cloud-server/:id/detail',
      children: [
        {
          path: '/cloud-server/:id/detail',
          component: () => import('@/views/idc/cloud-server/detail/index'),
          name: 'cloud-server.detail',
          meta: { auth: true, title: 'Chi tiết Server', icon: 'cloud-server', layout: 'cloud-server' }
        }
      ]
    },
    {
      path: '/volume',
      component: IdcLayoutPage,
      redirect: '/volume',
      children: [
        {
          path: '/volume',
          component: () => import('@/views/idc/volume/index'),
          name: 'volume.index',
          meta: { auth: true, title: 'Volume', icon: 'volume', layout: 'volume' }
        }
      ]
    },
    {
      path: '/volume/create',
      component: IdcLayoutPage,
      redirect: '/volume/create',
      children: [
        {
          path: '/volume/create',
          component: () => import('@/views/idc/volume/create'),
          name: 'volume.create',
          meta: { auth: true, title: 'Tạo Volume', icon: 'volume', layout: 'volume' }
        }
      ]
    },
    {
      path: '/snapshot',
      component: IdcLayoutPage,
      redirect: '/snapshot',
      children: [
        {
          path: '/snapshot',
          component: () => import('@/views/idc/snapshot/index'),
          name: 'snapshot.index',
          meta: { auth: true, title: 'Snapshot', icon: 'snapshot', layout: 'snapshot' }
        }
      ]
    },
    {
      path: '/snapshot/create',
      component: IdcLayoutPage,
      redirect: '/snapshot/create',
      children: [
        {
          path: '/snapshot/create',
          component: () => import('@/views/idc/snapshot/create'),
          name: 'snapshot.create',
          meta: { auth: true, title: 'Tạo Snapshot', icon: 'snapshot', layout: 'snapshot' }
        }
      ]
    },
    {
      path: '/ssh-keys',
      component: IdcLayoutPage,
      redirect: '/ssh-keys',
      children: [
        {
          path: '/ssh-keys',
          component: () => import('@/views/idc/ssh-keys/index'),
          name: 'ssh-keys.index',
          meta: { auth: true, title: 'SSH Key', icon: 'ssh-keys', layout: 'ssh-keys' }
        }
      ]
    },
    {
      path: '/ssh-keys/create',
      component: IdcLayoutPage,
      redirect: '/ssh-keys/create',
      children: [
        {
          path: '/ssh-keys/create',
          component: () => import('@/views/idc/ssh-keys/create'),
          name: 'ssh-keys.create',
          meta: { auth: true, title: 'Tạo SSH Key', icon: 'ssh-keys', layout: 'ssh-keys' }
        }
      ]
    },
    {
      path: '/account',
      component: IdcLayoutPage,
      redirect: '/account',
      children: [
        {
          path: '/account',
          component: () => import('@/views/idc/account/index'),
          name: 'account.index',
          meta: { auth: true, title: 'Tài khoản', icon: 'account', layout: 'account' }
        }
      ]
    },
    {
      path: '/billing',
      component: IdcLayoutPage,
      redirect: '/billing',
      children: [
        {
          path: '/billing',
          component: () => import('@/views/idc/billing/index'),
          name: 'billing.index',
          meta: { auth: true, title: 'Thanh toán', icon: 'billing', layout: 'billing' }
        }
      ]
    },
    {
      path: '/billing/success',
      component: IdcLayoutPage,
      redirect: '/billing/success',
      children: [
        {
          path: '/billing/success',
          component: () => import('@/views/idc/billing/success'),
          name: 'billing.success',
          meta: { auth: true, title: 'Thanh toán', icon: 'billing', layout: 'billing' }
        }
      ]
    },
    {
      path: '/billing/failure',
      component: IdcLayoutPage,
      redirect: '/billing/failure',
      children: [
        {
          path: '/billing/failure',
          component: () => import('@/views/idc/billing/failure'),
          name: 'billing.failure',
          meta: { auth: true, title: 'Thanh toán', icon: 'billing', layout: 'billing' }
        }
      ]
    },
    {
      path: '/billing/payment',
      component: BillingPayment,
      redirect: '/billing/payment',
      children: [
        {
          path: '/billing/payment',
          component: () => import('@/views/idc/billing/payment'),
          name: 'billing.payment',
          meta: { auth: true, title: 'Thanh toán', icon: 'billing', layout: 'billing' }
        }
      ]
    },
    {
      path: '/order/create',
      component: IdcLayoutPage,
      redirect: '/order/create',
      children: [
        {
          path: '/order/create',
          component: () => import('@/views/idc/order/create'),
          name: 'order.create',
          meta: { auth: true, title: 'Tạo Order', icon: 'order', layout: 'order' }
        }
      ]
    },
    {
      path: '/ticket',
      component: IdcLayoutPage,
      redirect: '/ticket',
      children: [
        {
          path: '/ticket',
          component: () => import('@/views/idc/ticket/index'),
          name: 'ticket.index',
          meta: { auth: true, title: 'Ticket', icon: 'ticket', layout: 'ticket' }
        }
      ]
    },
    {
      path: '/ticket/:id/detail',
      component: IdcLayoutPage,
      redirect: '/ticket/:id/detail',
      children: [
        {
          path: '/ticket/:id/detail',
          component: () => import('@/views/idc/ticket/detail'),
          name: 'ticket.detail',
          meta: { auth: true, title: 'Chi tiết Ticket', icon: 'ticket', layout: 'ticket' }
        }
      ]
    },
    {
      path: '/agency',
      component: IdcLayoutPage,
      children: [
        {
          path: '/',
          component: () => import('@/views/idc/agency/index'),
          name: 'agency.index',
          meta: { auth: true, title: 'Agency', icon: 'agency', layout: 'agency' }
        }
      ]
    },
    {
      path: '*',
      name: 'pageNotFound',
      component: PageNotFound,
      meta: {
        auth: true,
        title: 'Page Not Found'
      }
    },
    {
      path: '/500',
      name: 'serverError',
      component: InternalServerError,
      meta: {
        auth: true,
        title: 'Internal Server Error'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js